import React from 'react';

const SanitizedDiv = ({children, className, style}) => (<div className={className} style={style}>{children}</div>);

export default SanitizedDiv;